export default "/_next/static/images/discover-card-761aca494bd872f2ca0ebadb9f2033cb.png";